// extracted by mini-css-extract-plugin
module.exports = {"fallbackWrapper":"ErrorFallbackContent_fallbackWrapper__cE_To"};